/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { PublishQuoteAndSendViaEmailModal_QuoteFragmentDoc, PublishQuoteAndSendViaEmailModal_ProjectFragmentDoc } from '../modals/PublishQuoteAndSendViaEmailModal.generated.js';
import { DocumentRow__DocumentFragmentDoc } from '../Quotes.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PublishQuoteButton_QuoteFragment = { __typename: 'Quote', id: string, sentAt?: any | null, title: string, createdAt: any, isBinding: boolean, isPublished: boolean, agreement: Types.Agreement, needsAgreement: boolean, expirationDate?: any | null, templateOriginQuoteId?: string | null, contractor: { __typename: 'DocActor', id: string, address?: { __typename: 'AddressSnapshot', countryCode: string, postalCode: string, city: string, streetLines1: string } | null }, contractee: { __typename: 'DocActor', id: string, companyName: string }, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null, agreedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null };

export type PublishQuoteButton_ProjectFragment = { __typename: 'Project', id: string };

export type PublishQuoteMutationVariables = Types.Exact<{
  input: Types.PublishQuoteInput;
}>;


export type PublishQuoteMutation = { publishQuote: { __typename: 'PublishQuoteResult', quote: { __typename: 'Quote', id: string, isPublished: boolean, sentAt?: any | null, publishedAt?: any | null, title: string, description: string, createdAt: any, owningSystemOrganisationId: string, earliestDate?: any | null, expirationDate?: any | null, duration?: number | null, contractType: Types.ContractType, discountPercentage: number, isBinding: boolean, decliningReason: string, agreement: Types.Agreement, acceptedAt?: any | null, changeDecliningReason: string, needsAgreement: boolean, quoteForRequirement?: { __typename: 'Requirement', id: string, title: string } | null, author: { __typename: 'User', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string }, agreedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null, attachments: Array<{ __typename: 'Attachment', id: string, title: string, mimeType: string, url: string, group: string }> } } };

export type PublishQuoteButton_SetContractorAddressMutationVariables = Types.Exact<{
  input: Types.ModifyQuoteDocActorInput;
}>;


export type PublishQuoteButton_SetContractorAddressMutation = { modifyQuoteDocActor: { __typename: 'ModifyQuoteDocActorResult', docActor: { __typename: 'DocActor', id: string, address?: { __typename: 'AddressSnapshot', countryCode: string, postalCode: string, city: string, streetLines1: string } | null } } };

export const PublishQuoteButton_QuoteFragmentDoc = gql`
    fragment PublishQuoteButton_Quote on Quote {
  id
  sentAt
  contractor {
    id
    address {
      countryCode
      postalCode
      city
      streetLines1
    }
  }
  ...PublishQuoteAndSendViaEmailModal_Quote
}
    ${PublishQuoteAndSendViaEmailModal_QuoteFragmentDoc}`;
export const PublishQuoteButton_ProjectFragmentDoc = gql`
    fragment PublishQuoteButton_Project on Project {
  id
  ...PublishQuoteAndSendViaEmailModal_Project
}
    ${PublishQuoteAndSendViaEmailModal_ProjectFragmentDoc}`;
export const PublishQuoteDocument = gql`
    mutation PublishQuote($input: PublishQuoteInput!) {
  publishQuote(input: $input) {
    quote {
      id
      isPublished
      sentAt
      publishedAt
      ...DocumentRow__Document
    }
  }
}
    ${DocumentRow__DocumentFragmentDoc}`;
export type PublishQuoteMutationFn = Apollo.MutationFunction<PublishQuoteMutation, PublishQuoteMutationVariables>;

/**
 * __usePublishQuoteMutation__
 *
 * To run a mutation, you first call `usePublishQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishQuoteMutation, { data, loading, error }] = usePublishQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishQuoteMutation(baseOptions?: Apollo.MutationHookOptions<PublishQuoteMutation, PublishQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishQuoteMutation, PublishQuoteMutationVariables>(PublishQuoteDocument, options);
      }
export type PublishQuoteMutationHookResult = ReturnType<typeof usePublishQuoteMutation>;
export type PublishQuoteMutationResult = Apollo.MutationResult<PublishQuoteMutation>;
export type PublishQuoteMutationOptions = Apollo.BaseMutationOptions<PublishQuoteMutation, PublishQuoteMutationVariables>;
export const PublishQuoteButton_SetContractorAddressDocument = gql`
    mutation PublishQuoteButton_SetContractorAddress($input: ModifyQuoteDocActorInput!) {
  modifyQuoteDocActor(input: $input) {
    docActor {
      id
      address {
        countryCode
        postalCode
        city
        streetLines1
      }
    }
  }
}
    `;
export type PublishQuoteButton_SetContractorAddressMutationFn = Apollo.MutationFunction<PublishQuoteButton_SetContractorAddressMutation, PublishQuoteButton_SetContractorAddressMutationVariables>;

/**
 * __usePublishQuoteButton_SetContractorAddressMutation__
 *
 * To run a mutation, you first call `usePublishQuoteButton_SetContractorAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishQuoteButton_SetContractorAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishQuoteButtonSetContractorAddressMutation, { data, loading, error }] = usePublishQuoteButton_SetContractorAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishQuoteButton_SetContractorAddressMutation(baseOptions?: Apollo.MutationHookOptions<PublishQuoteButton_SetContractorAddressMutation, PublishQuoteButton_SetContractorAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishQuoteButton_SetContractorAddressMutation, PublishQuoteButton_SetContractorAddressMutationVariables>(PublishQuoteButton_SetContractorAddressDocument, options);
      }
export type PublishQuoteButton_SetContractorAddressMutationHookResult = ReturnType<typeof usePublishQuoteButton_SetContractorAddressMutation>;
export type PublishQuoteButton_SetContractorAddressMutationResult = Apollo.MutationResult<PublishQuoteButton_SetContractorAddressMutation>;
export type PublishQuoteButton_SetContractorAddressMutationOptions = Apollo.BaseMutationOptions<PublishQuoteButton_SetContractorAddressMutation, PublishQuoteButton_SetContractorAddressMutationVariables>;